export enum ERROR_FUNCTION_TYPE {
  LINEAR = 1,
  EXPONENTIAL = 2,
}
